import {
  IonItem,
  IonLabel,
  IonInput,
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonGrid,
  IonCol,
  IonRow,
  IonFooter,
  useIonViewWillEnter,
  useIonViewDidEnter,
  IonSegment,
  IonSegmentButton,
  IonRadioGroup,
  IonRadio,
  IonAccordionGroup,
  IonList,
  IonAccordion,
  IonButtons,
  IonIcon,
  IonButton,
  IonBadge,
  IonImg,
} from "@ionic/react";

import {
  Datepicker,
  Page,
  setOptions,
  localePl,
  Input,
  Popup,
  Select,
  Switch,
} from "@mobiscroll/react";
import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  ChangeEvent,
  useMemo,
  RefObject,
} from "react";

import Button from "./../components/Ebert/Button";

import Header from "../components/JobsterHeader";
import ContentBox from "../components/ContentBox";

import { useDebounce, useDebouncedCallback } from "use-debounce";

import { Main } from "../components/HomeScript";
import { isPlatform, ScrollDetail } from "@ionic/core";

import MobiInput from "../components/Mobi/MobiInput";
import { LocationModelAttributes } from "../components/Order/Location";
import { isValidPostCode, onScrollHeader } from "../components/Common";
import MobiPopup from "../components/Mobi/MobiPopup";

import "./Lesson.scss";

import JobPost from "../components/Home/JobPost";

import Footer from "../components/Footer";
import { useHistory } from "react-router";
import MobiButton from "../components/Mobi/MobiButton";

import { Link } from "react-router-dom";
import CustomHeaderFade from "../components/CustomHeaderFade";
import CustomHeaderCondense from "../components/CustomHeaderCondense";
import MobiTextarea from "../components/Mobi/MobiTextarea";
import { cartOutline, contractOutline, layersOutline, personCircle } from "ionicons/icons";

import { SegmentScroll } from "../components/Ebert/Methods";
import HeaderToolbarMobile from "../components/Header/HeaderToolbarMobile";

import {
  GlobalStateProvider,
  useGlobalState,
  GlobalStateInterface,
} from "./../GlobalStateProvider";

setOptions({
  theme: "ios",
  themeVariant: "light",
});

function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}

const Home: React.FC = () => {
  let _localePl = localePl;
  _localePl.setText = "Ustaw";

  const { state, setState } = useGlobalState();

  const [selected, setSelected] = useState("kurs");

  const [noteTaking, setNoteTaking] = useState(false);

  type NotesProps = {
    id: number;
    note: string;
    buttonTime: string;
    buttonText: string;
    date: string;
  };

  const [notes, setNotes] = useState<NotesProps[]>([]);

  const [newNoteText, setNewNoteText] = useState("");

  const [segmentValue, setSegmentValue] = useState("description");

  const [showHeaderSegment, setShowHeaderSegment] = useState(false);

  const [segmentScrollLeft, setSegmentScrollLeft] = useState(0);

  const segmentContainerRef = useRef<HTMLDivElement>(null);
  const ionSegmentRef = useRef<HTMLIonSegmentElement>(null); 
  const ionSegmentHeaderRef = useRef<HTMLIonSegmentElement>(null); 
  const ionHeaderRef = useRef<HTMLIonHeaderElement>(null);

  const ionAccordionRef = useRef<HTMLIonAccordionGroupElement>(null);

  useIonViewWillEnter(() => {

    segmentContainerRef.current?.querySelectorAll(".segment-single").forEach((_e) => {
      const parsed = _e as HTMLDivElement;
      parsed.style.display = "";
    });

    const e = segmentContainerRef.current?.querySelector(".segment-single" + "." + segmentValue) as HTMLDivElement;

    console.log(e)

    if(e)
    {
      e.style.display = "block";
    }

    

  })

  useIonViewDidEnter(() => {
    if(ionAccordionRef.current && !(isPlatform("mobile") || isPlatform("tablet")))
    {
      ionAccordionRef.current.value = ["tobuy", "tobuy2"];
    }
  })
  
  useEffect(() => {
    setTimeout(() => {
      if (showHeaderSegment && ionSegmentHeaderRef.current) {
        ionSegmentHeaderRef.current.scrollTo(segmentScrollLeft, 0);
      } else if (!showHeaderSegment && ionSegmentRef.current) {
        ionSegmentRef.current.scrollTo(segmentScrollLeft, 0);
      }
    }, 5);
  }, [showHeaderSegment]);

  return (
    <IonPage>
      <CustomHeaderFade
        ionHeaderRef={ionHeaderRef}
        title="Matematyka - podstawy"
        long={true}
        arrow={true}
        extraButtons={<HeaderToolbarMobile />}
        segment={
          (isPlatform("mobile") || isPlatform("tablet")) &&
          showHeaderSegment ? (
            <IonToolbar>
              <IonSegment
                onScroll={(event) => {
                  const target = event.target as HTMLIonSegmentElement;
                  if (target) {
                    setSegmentScrollLeft(target.scrollLeft);
                  }
                }}
                ref={ionSegmentHeaderRef}
                value={segmentValue}
                className="px-3"
                mode="md"
                scrollable
                onIonChange={(event) => {
                  setSegmentValue(
                    event.detail.value ? event.detail.value : "buy"
                  );

                  if (segmentContainerRef.current) {
                    segmentContainerRef.current
                      .querySelectorAll(".segment-single")
                      .forEach((_e) => {
                        const parsed = _e as HTMLDivElement;
                        parsed.style.display = "";
                      });

                    const e = segmentContainerRef.current.querySelector(
                      ".segment-single" + "." + event.detail.value
                    ) as HTMLDivElement;

                    if (e) {
                      e.style.display = "block";
                    }

                    segmentContainerRef.current
                      ?.querySelector("#under-segment")
                      ?.scrollIntoView({ block: "start" });
                  }
                }}
              >
                <IonSegmentButton value="description">
                  <IonLabel>Opis</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="lessons">
                  <IonLabel>Spis lekcji</IonLabel>
                </IonSegmentButton>

                <IonSegmentButton value="buy">
                  <IonLabel>Kup kurs</IonLabel>
                </IonSegmentButton>

                <IonSegmentButton value="notes">
                  <IonLabel>Notatki</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="comments">
                  <IonLabel>Komentarze</IonLabel>
                </IonSegmentButton>
              </IonSegment>
            </IonToolbar>
          ) : (
            <></>
          )
        }
      >
        <div style={{ textAlign: "center" }}>
          <strong style={{ letterSpacing: "1px" }}>Matematyka</strong>
          <br />
          <span>Geometria</span>
        </div>
      </CustomHeaderFade>

      <IonContent
        id="lesson-page-controller"
        className="background-lightgrey slide-transition-enter"
        scrollEvents={true}
        onIonScroll={(event: CustomEvent<ScrollDetail>) => {
          SegmentScroll(
            event,
            setShowHeaderSegment,
            showHeaderSegment,
            ionSegmentRef,
            ionHeaderRef
          );
        }}
      >
        {/* <CustomHeaderCondense title="Lista zleceń" /> */}

        <div className="container container-wd">
          <div
            className="row pt-0 pt-md-8 pb-10 px-md-4 segment-container"
            ref={segmentContainerRef}
          >
            <div className="col-lg-8 padding-remove">
              <div className="shadow-basic mb-1 mb-md-6">
                <a className="d-block sk-thumbnail mb-0">
                  <div className="h-90p w-90p rounded-circle bg-white size-30-all d-inline-flex align-items-center justify-content-center position-absolute center z-index-1">
                    {/* Icon */}
                    <svg
                      width={14}
                      height={16}
                      viewBox="0 0 14 16"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.8704 6.15374L3.42038 0.328572C2.73669 -0.0923355 1.9101 -0.109836 1.20919 0.281759C0.508282 0.673291 0.0898438 1.38645 0.0898438 2.18929V13.7866C0.0898438 15.0005 1.06797 15.9934 2.27016 16C2.27344 16 2.27672 16 2.27994 16C2.65563 16 3.04713 15.8822 3.41279 15.6591C3.70694 15.4796 3.79991 15.0957 3.62044 14.8016C3.44098 14.5074 3.05697 14.4144 2.76291 14.5939C2.59188 14.6982 2.42485 14.7522 2.27688 14.7522C1.82328 14.7497 1.33763 14.3611 1.33763 13.7866V2.18933C1.33763 1.84492 1.51713 1.53907 1.81775 1.3711C2.11841 1.20314 2.47294 1.21064 2.76585 1.39098L12.2159 7.21615C12.4999 7.39102 12.6625 7.68262 12.6618 8.01618C12.6611 8.34971 12.4974 8.64065 12.2118 8.81493L5.37935 12.9983C5.08548 13.1783 4.9931 13.5623 5.17304 13.8562C5.35295 14.1501 5.73704 14.2424 6.03092 14.0625L12.8625 9.87962C13.5166 9.48059 13.9081 8.78496 13.9096 8.01868C13.9112 7.25249 13.5226 6.55524 12.8704 6.15374Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <img
                    className="rounded shadow-light-lg"
                    src="assets/img/products/product-2.jpg"
                    alt="..."
                  />
                  <div
                    className="d-none d-lg-flex"
                    style={{
                      position: "absolute",
                      background: "white",
                      padding: 7,
                      height: "100%",
                      display: "flex",
                    }}
                  >
                    <div
                      className="pt-5 pb-4 px-5 px-lg-3 px-xl-5"
                      style={{
                        margin: "auto 0",
                      }}
                    >
                      <div className="mb-4">
                        <IonRadioGroup
                          value={selected}
                          onIonChange={(e) => setSelected(e.detail.value)}
                        >
                          <IonItem
                            lines="none"
                            className={
                              selected == "lekcja"
                                ? "border-active-2"
                                : "border-transparent-2"
                            }
                            style={{
                              borderRadius: "14px",
                              marginBottom: "5px",
                            }}
                          >
                            <div className="mb-2 mt-2">
                              <div className="d-flex align-items-center ">
                                <span className="ms-0">Lekcja</span>
                              </div>
                              <div className="d-flex align-items-center mb-0">
                                <ins className="h2 mb-0 ms-2">49,99 zł</ins>
                              </div>
                            </div>
                            <IonRadio slot="end" value="lekcja" />
                          </IonItem>
                          <IonItem
                            lines="none"
                            className={
                              selected == "kurs"
                                ? "border-active-2"
                                : "border-transparent-2"
                            }
                            style={{
                              borderRadius: "14px",
                              marginBottom: "5px",
                            }}
                          >
                            <div className="mb-2 mt-2">
                              <div className="d-flex align-items-center mb-0">
                                <span className="ms-0" style={{}}>
                                  Cały kurs
                                </span>
                              </div>
                              <div className="d-flex align-items-center mb-0">
                                <ins className="h2 mb-0 ms-2">359,00 zł</ins>
                                <del
                                  className="ms-3"
                                  style={{
                                    marginTop: "-18px",
                                  }}
                                >
                                  599,00 zł
                                </del>
                              </div>
                            </div>
                            <IonRadio slot="end" value="kurs" />
                          </IonItem>
                        </IonRadioGroup>
                      </div>

                      <Button
                        onClick={() => {
                          setTimeout(() => {
                            if (state.cart) {
                              let tempCart = state.cart;
                              tempCart.push({
                                category: "Matematyka",
                                name: "Trygonometria",
                                price: "100,00 zł",
                              });
                              setState((prev) => ({
                                ...prev,
                                ...{ cart: tempCart },
                              }));
                            } else {
                              setState((prev) => ({
                                ...prev,
                                ...{
                                  cart: [
                                    {
                                      category: "Matematyka",
                                      name: "Trygonometria",
                                      price: "100,00 zł",
                                    },
                                  ],
                                },
                              }));
                            }

                            if (ionHeaderRef.current) {
                              const element =
                                ionHeaderRef.current.querySelector(
                                  "#popover-cart-click"
                                ) as HTMLDivElement;
                              if (element) {
                                element.click();
                              }
                            }
                          }, 200);
                        }}
                        label="DODAJ DO KOSZYKA"
                        style={{
                          width: "100%",
                        }}
                        height={60}
                        fontSize={18}
                        className="mb-6 prevent-dismiss"
                      />
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item d-flex align-items-center py-3">
                          <div className="text-secondary d-flex icon-uxs">
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.3164 4.20996C13.985 4.37028 13.8464 4.76904 14.0067 5.10026C14.4447 6.00505 14.6667 6.98031 14.6667 8C14.6667 11.6759 11.6759 14.6667 8 14.6667C4.32406 14.6667 1.33333 11.6759 1.33333 8C1.33333 4.32406 4.32406 1.33333 8 1.33333C9.52328 1.33333 10.9543 1.83073 12.1387 2.77165C12.4259 3.00098 12.846 2.95296 13.0754 2.66471C13.3047 2.37663 13.2567 1.95703 12.9683 1.72803C11.5661 0.613607 9.8016 0 8 0C3.58903 0 0 3.58903 0 8C0 12.411 3.58903 16 8 16C12.411 16 16 12.411 16 8C16 6.77767 15.7331 5.60628 15.2067 4.51969C15.0467 4.18766 14.6466 4.04932 14.3164 4.20996Z"
                                fill="currentColor"
                              />
                              <path
                                d="M7.99967 2.66663C7.63167 2.66663 7.33301 2.96529 7.33301 3.33329V7.99996C7.33301 8.36796 7.63167 8.66663 7.99967 8.66663H11.333C11.701 8.66663 11.9997 8.36796 11.9997 7.99996C11.9997 7.63196 11.701 7.33329 11.333 7.33329H8.66634V3.33329C8.66634 2.96529 8.36768 2.66663 7.99967 2.66663Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          <h6 className="mb-0 ms-3 me-auto">Duration</h6>
                          <span>43 weeks</span>
                        </li>
                        <li className="list-group-item d-flex align-items-center py-3">
                          <div className="text-secondary d-flex icon-uxs">
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.7262 1.94825C13.4059 0.396725 10.401 0.315126 8.00002 1.73839C5.59897 0.315126 2.59406 0.396725 0.273859 1.94825C0.102729 2.06241 -3.54271e-05 2.25456 6.30651e-07 2.46027V14.6553C-0.000323889 14.8826 0.124616 15.0914 0.324917 15.1987C0.525109 15.3058 0.768066 15.294 0.9569 15.168C2.98471 13.8111 5.63063 13.8111 7.65844 15.168C7.66645 15.1735 7.67568 15.1747 7.68368 15.1796C7.69169 15.1846 7.7003 15.1932 7.70953 15.1987C7.73102 15.2079 7.75302 15.2159 7.77538 15.2227C7.79773 15.2329 7.82077 15.2415 7.84428 15.2486C7.87828 15.2564 7.91286 15.2616 7.94766 15.264C7.96551 15.264 7.98213 15.2714 7.99998 15.2714C8.00492 15.2714 8.00982 15.2714 8.01538 15.2714C8.03604 15.2699 8.05655 15.2672 8.07693 15.2634C8.10808 15.2602 8.13895 15.2547 8.16923 15.2467C8.19018 15.2399 8.21074 15.2319 8.23078 15.2227C8.24986 15.2147 8.27016 15.2104 8.28862 15.2006C8.29724 15.1956 8.30402 15.1883 8.31264 15.1827C8.32125 15.1772 8.3311 15.1753 8.33971 15.1698C10.3675 13.8129 13.0134 13.8129 15.0413 15.1698C15.3233 15.3595 15.7057 15.2846 15.8953 15.0026C15.9643 14.9 16.0008 14.779 16 14.6554V2.46027C16 2.25456 15.8973 2.06241 15.7262 1.94825ZM7.38462 13.6036C5.43516 12.6896 3.18022 12.6896 1.23076 13.6036V2.79993C3.12732 1.67313 5.48806 1.67313 7.38462 2.79993V13.6036ZM14.7692 13.6036C12.8198 12.6896 10.5648 12.6896 8.61538 13.6036V2.79993C10.5119 1.67313 12.8727 1.67313 14.7692 2.79993V13.6036Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          <h6 className="mb-0 ms-3 me-auto">Lectures</h6>
                          <span>32</span>
                        </li>
                        <li className="list-group-item d-flex align-items-center py-3">
                          <div className="text-secondary d-flex icon-uxs">
                            <svg
                              width={20}
                              height={20}
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.1947 7.06802L14.6315 7.9985C14.2476 7.31186 13.712 6.71921 13.0544 6.25992C12.8525 6.11877 12.6421 5.99365 12.4252 5.88303C13.0586 5.25955 13.452 4.39255 13.452 3.43521C13.452 1.54098 11.9124 -1.90735e-06 10.0197 -1.90735e-06C8.12714 -1.90735e-06 6.58738 1.54098 6.58738 3.43521C6.58738 4.39255 6.98075 5.25955 7.61414 5.88303C7.39731 5.99365 7.1869 6.11877 6.98502 6.25992C6.32752 6.71921 5.79178 7.31186 5.40787 7.9985L2.8447 7.06802C2.33612 6.88339 1.79688 7.26044 1.79688 7.80243V16.5178C1.79688 16.8465 2.00256 17.14 2.31155 17.2522L9.75312 19.9536C9.93073 20.018 10.1227 20.0128 10.2863 19.9536L17.7278 17.2522C18.0368 17.14 18.2425 16.8465 18.2425 16.5178V7.80243C18.2425 7.26135 17.704 6.88309 17.1947 7.06802ZM10.0197 1.5625C11.0507 1.5625 11.8895 2.40265 11.8895 3.43521C11.8895 4.46777 11.0507 5.30792 10.0197 5.30792C8.98866 5.30792 8.14988 4.46777 8.14988 3.43521C8.14988 2.40265 8.98866 1.5625 10.0197 1.5625ZM9.23844 18.1044L3.35938 15.9703V8.91724L9.23844 11.0513V18.1044ZM10.0197 9.67255L6.90644 8.54248C7.58164 7.51892 8.75184 6.87042 10.0197 6.87042C11.2875 6.87042 12.4577 7.51892 13.1329 8.54248L10.0197 9.67255ZM16.68 15.9703L10.8009 18.1044V11.0513L16.68 8.91724V15.9703Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          <h6 className="mb-0 ms-3 me-auto">Enrolled</h6>
                          <span>1982 students</span>
                        </li>
                        <li className="list-group-item d-flex align-items-center py-3">
                          <div className="text-secondary d-flex icon-uxs">
                            <svg
                              width={20}
                              height={20}
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16.5465 5.13024L15.2322 4.02945L14.9329 2.34131C14.8335 1.78023 14.348 1.37335 13.7783 1.37335C13.778 1.37335 13.7775 1.37335 13.7772 1.37335L12.0628 1.37488L10.7485 0.274205C10.3114 -0.0919028 9.67738 -0.0913556 9.24091 0.275574L7.92861 1.37875L6.2142 1.38035C5.64405 1.3809 5.15872 1.78887 5.06026 2.35042L4.76408 4.03907L3.45178 5.14228C3.01535 5.50917 2.90582 6.13362 3.19137 6.62712L4.04992 8.1111L3.75378 9.79967C3.65524 10.3613 3.97276 10.91 4.50875 11.1046L5.9543 11.6292L5.95989 18.8268C5.95989 19.2647 6.20095 19.6629 6.58899 19.8659C6.76059 19.9556 6.94712 20 7.13295 20C7.36737 20 7.60062 19.9294 7.8013 19.7901L9.9861 18.2734L12.1709 19.7901C12.5306 20.0398 12.9951 20.0689 13.3832 19.8659C13.7712 19.6629 14.0123 19.2647 14.0123 18.8268V11.6377L15.5005 11.0945C16.0361 10.899 16.3526 10.3496 16.2531 9.78825L15.9538 8.10015L16.8096 6.61461C17.0943 6.12056 16.9836 5.49631 16.5465 5.13024ZM10.3205 17.078C10.1194 16.9385 9.85281 16.9385 9.65178 17.078L7.13264 18.8265C7.13264 18.8264 7.13264 18.8263 7.13264 18.8263L7.12842 13.3771C7.35154 13.6218 7.66652 13.7592 7.99315 13.7592C8.12738 13.7592 8.26357 13.7361 8.39608 13.6877L10.0065 13.0999L11.6181 13.6848C12.0517 13.842 12.5242 13.7298 12.8396 13.4196L12.8395 18.8266L10.3205 17.078ZM14.9377 7.51475C14.8003 7.75327 14.7511 8.03382 14.7992 8.30482L15.0984 9.99292L13.4878 10.5808C13.286 10.6545 13.1095 10.783 12.9761 10.949C12.9697 10.9566 12.9639 10.9647 12.9579 10.9727C12.9277 11.0123 12.899 11.0533 12.8739 11.0969L12.0185 12.5825C12.0185 12.5825 12.0183 12.5825 12.0181 12.5824L10.4065 11.9976C10.1478 11.9037 9.86297 11.9039 9.6044 11.9983L7.99393 12.5861L7.13538 11.1022C7.08925 11.0224 7.03339 10.9496 6.97073 10.8835C6.96507 10.8774 6.95975 10.871 6.95381 10.8652C6.83236 10.7425 6.68464 10.6468 6.52039 10.5871L4.90882 10.0022L5.205 8.31358C5.2525 8.04245 5.20277 7.76199 5.06495 7.52378L4.20639 6.03984L5.51869 4.93663C5.72942 4.75952 5.87163 4.51263 5.91912 4.24159L6.2153 2.55298L7.92963 2.55138C8.20489 2.55114 8.47254 2.45346 8.68319 2.27635L9.99549 1.17318L11.3098 2.27389C11.5205 2.45041 11.7879 2.54759 12.0629 2.54759H12.0638L13.7783 2.54602L14.0775 4.23416C14.1255 4.50517 14.2682 4.75166 14.4792 4.92842L15.7935 6.02921L14.9377 7.51475Z"
                                fill="currentColor"
                              />
                              <path
                                d="M9.99928 3.64673C8.13493 3.64673 6.61816 5.1635 6.61816 7.02785C6.61816 8.89221 8.13493 10.409 9.99928 10.409C11.8636 10.409 13.3804 8.89221 13.3804 7.02785C13.3804 5.1635 11.8636 3.64673 9.99928 3.64673ZM9.99928 9.23631C8.78154 9.23631 7.79083 8.2456 7.79083 7.02785C7.79083 5.81011 8.78154 4.8194 9.99928 4.8194C11.217 4.8194 12.2078 5.81011 12.2078 7.02785C12.2078 8.2456 11.217 9.23631 9.99928 9.23631Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          <h6 className="mb-0 ms-3 me-auto">Certificate</h6>
                          <span>Yes</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </a>
              </div>

              <IonSegment
                ref={ionSegmentRef}
                value={segmentValue}
                className="mb-4 px-3"
                mode="md"
                scrollable
                onScroll={(event) => {
                  const target = event.target as HTMLIonSegmentElement;
                  if (target) {
                    setSegmentScrollLeft(target.scrollLeft);
                  }
                }}
                onIonChange={(event) => {
                  setSegmentValue(
                    event.detail.value ? event.detail.value : "description"
                  );

                  if (segmentContainerRef.current) {
                    segmentContainerRef.current
                      .querySelectorAll(".segment-single")
                      .forEach((_e) => {
                        const parsed = _e as HTMLDivElement;
                        parsed.style.display = "";
                      });

                    const e = segmentContainerRef.current.querySelector(
                      ".segment-single" + "." + event.detail.value
                    ) as HTMLDivElement;

                    console.log(e);

                    if (e) {
                      e.style.display = "block";
                    }

                    // setTimeout(() => {
                    //   segmentContainerRef.current?.querySelector("#under-segment")?.scrollIntoView({ block: "start" });
                    // }, 10);
                  }
                }}
              >
                {isPlatform("mobile") || isPlatform("tablet") ? (
                  <>
                    <IonSegmentButton value="description">
                      <IonLabel>Opis</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="lessons">
                      <IonLabel>Spis lekcji</IonLabel>
                    </IonSegmentButton>

                    <IonSegmentButton value="buy">
                      <IonLabel>Kup kurs</IonLabel>
                    </IonSegmentButton>

                    <IonSegmentButton value="notes">
                      <IonLabel>Notatki</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="comments">
                      <IonLabel>Komentarze</IonLabel>
                    </IonSegmentButton>
                  </>
                ) : (
                  <>
                    <IonSegmentButton value="description">
                      <IonLabel>Opis</IonLabel>
                    </IonSegmentButton>

                    <IonSegmentButton value="notes">
                      <IonLabel>Notatki</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="comments">
                      <IonLabel>Komentarze</IonLabel>
                    </IonSegmentButton>
                  </>
                )}
              </IonSegment>

              <div
                className="d-block d-lg-none"
                id="under-segment"
                style={{
                  scrollMargin: "1rem",
                }}
              ></div>

              <div className="px-3 ">
                <div className="segment-single buy d-lg-none">
                  <div
                    style={{
                      background: "white",
                      padding: 7,
                    }}
                    className="shadow-basic rounded mb-7"
                  >
                    <div
                      className="pt-7 pb-7 px-2 px-md-5 px-lg-3 px-xl-5"
                      style={{
                        margin: "auto 0",
                      }}
                    >
                      <div className="row">
                        <div className="col-12 col-lg-6 mb-6">
                          <div className="mb-4">
                            <IonRadioGroup
                              value={selected}
                              onIonChange={(e) => setSelected(e.detail.value)}
                            >
                              <IonItem
                                lines="none"
                                className={
                                  selected == "lekcja"
                                    ? "border-active-2"
                                    : "border-transparent-2"
                                }
                                style={{
                                  borderRadius: "14px",
                                  marginBottom: "5px",
                                }}
                              >
                                <div className="mb-2 mt-2 w-100">
                                  <div className="d-flex align-items-center ">
                                    <span className="ms-0">Lekcja</span>
                                  </div>
                                  <div className="d-flex align-items-center mb-0">
                                    <ins className="h2 mb-0 ms-2">49,99 zł</ins>
                                  </div>
                                </div>
                                <IonRadio slot="end" value="lekcja" />
                              </IonItem>
                              <IonItem
                                lines="none"
                                className={
                                  selected == "kurs"
                                    ? "border-active-2"
                                    : "border-transparent-2"
                                }
                                style={{
                                  borderRadius: "14px",
                                  marginBottom: "5px",
                                }}
                              >
                                <div className="mb-2 mt-2">
                                  <div className="d-flex align-items-center mb-0">
                                    <span className="ms-0" style={{}}>
                                      Cały kurs
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center mb-0">
                                    <ins className="h2 mb-0 ms-2">
                                      359,00 zł
                                    </ins>
                                    <del
                                      className="ms-3"
                                      style={{
                                        marginTop: "-18px",
                                      }}
                                    >
                                      599,00 zł
                                    </del>
                                  </div>
                                </div>
                                <IonRadio slot="end" value="kurs" />
                              </IonItem>
                            </IonRadioGroup>
                          </div>

                          <Button
                            onClick={() => {
                              setTimeout(() => {
                                if (state.cart) {
                                  let tempCart = state.cart;
                                  tempCart.push({
                                    category: "Matematyka",
                                    name: "Trygonometria",
                                    price: "100,00 zł",
                                  });
                                  setState((prev) => ({
                                    ...prev,
                                    ...{ cart: tempCart },
                                  }));
                                } else {
                                  setState((prev) => ({
                                    ...prev,
                                    ...{
                                      cart: [
                                        {
                                          category: "Matematyka",
                                          name: "Trygonometria",
                                          price: "100,00 zł",
                                        },
                                      ],
                                    },
                                  }));
                                }

                                if (ionHeaderRef.current) {
                                  if (
                                    isPlatform("mobile") ||
                                    isPlatform("tablet")
                                  ) {
                                    const element =
                                      ionHeaderRef.current.querySelector(
                                        ".popover-cart-click"
                                      ) as HTMLDivElement;
                                    if (element) {
                                      element.click();
                                    }
                                  } else {
                                    const element =
                                      ionHeaderRef.current.querySelector(
                                        "#popover-cart-click"
                                      ) as HTMLDivElement;
                                    if (element) {
                                      element.click();
                                    }
                                  }
                                }
                              }, 200);
                            }}
                            label="DODAJ DO KOSZYKA"
                            className="prevent-dismiss"
                            style={{
                              width: "100%",
                            }}
                            height={60}
                            fontSize={18}
                          />
                        </div>

                        <div
                          className="col-12 col-lg-6"
                          style={{
                            margin: "auto 0px",
                          }}
                        >
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item d-flex align-items-center py-3">
                              <div className="text-secondary d-flex icon-uxs">
                                <svg
                                  width={16}
                                  height={16}
                                  viewBox="0 0 16 16"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14.3164 4.20996C13.985 4.37028 13.8464 4.76904 14.0067 5.10026C14.4447 6.00505 14.6667 6.98031 14.6667 8C14.6667 11.6759 11.6759 14.6667 8 14.6667C4.32406 14.6667 1.33333 11.6759 1.33333 8C1.33333 4.32406 4.32406 1.33333 8 1.33333C9.52328 1.33333 10.9543 1.83073 12.1387 2.77165C12.4259 3.00098 12.846 2.95296 13.0754 2.66471C13.3047 2.37663 13.2567 1.95703 12.9683 1.72803C11.5661 0.613607 9.8016 0 8 0C3.58903 0 0 3.58903 0 8C0 12.411 3.58903 16 8 16C12.411 16 16 12.411 16 8C16 6.77767 15.7331 5.60628 15.2067 4.51969C15.0467 4.18766 14.6466 4.04932 14.3164 4.20996Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M7.99967 2.66663C7.63167 2.66663 7.33301 2.96529 7.33301 3.33329V7.99996C7.33301 8.36796 7.63167 8.66663 7.99967 8.66663H11.333C11.701 8.66663 11.9997 8.36796 11.9997 7.99996C11.9997 7.63196 11.701 7.33329 11.333 7.33329H8.66634V3.33329C8.66634 2.96529 8.36768 2.66663 7.99967 2.66663Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </div>
                              <h6 className="mb-0 ms-3 me-auto">Duration</h6>
                              <span>43 weeks</span>
                            </li>
                            <li className="list-group-item d-flex align-items-center py-3">
                              <div className="text-secondary d-flex icon-uxs">
                                <svg
                                  width={16}
                                  height={16}
                                  viewBox="0 0 16 16"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M15.7262 1.94825C13.4059 0.396725 10.401 0.315126 8.00002 1.73839C5.59897 0.315126 2.59406 0.396725 0.273859 1.94825C0.102729 2.06241 -3.54271e-05 2.25456 6.30651e-07 2.46027V14.6553C-0.000323889 14.8826 0.124616 15.0914 0.324917 15.1987C0.525109 15.3058 0.768066 15.294 0.9569 15.168C2.98471 13.8111 5.63063 13.8111 7.65844 15.168C7.66645 15.1735 7.67568 15.1747 7.68368 15.1796C7.69169 15.1846 7.7003 15.1932 7.70953 15.1987C7.73102 15.2079 7.75302 15.2159 7.77538 15.2227C7.79773 15.2329 7.82077 15.2415 7.84428 15.2486C7.87828 15.2564 7.91286 15.2616 7.94766 15.264C7.96551 15.264 7.98213 15.2714 7.99998 15.2714C8.00492 15.2714 8.00982 15.2714 8.01538 15.2714C8.03604 15.2699 8.05655 15.2672 8.07693 15.2634C8.10808 15.2602 8.13895 15.2547 8.16923 15.2467C8.19018 15.2399 8.21074 15.2319 8.23078 15.2227C8.24986 15.2147 8.27016 15.2104 8.28862 15.2006C8.29724 15.1956 8.30402 15.1883 8.31264 15.1827C8.32125 15.1772 8.3311 15.1753 8.33971 15.1698C10.3675 13.8129 13.0134 13.8129 15.0413 15.1698C15.3233 15.3595 15.7057 15.2846 15.8953 15.0026C15.9643 14.9 16.0008 14.779 16 14.6554V2.46027C16 2.25456 15.8973 2.06241 15.7262 1.94825ZM7.38462 13.6036C5.43516 12.6896 3.18022 12.6896 1.23076 13.6036V2.79993C3.12732 1.67313 5.48806 1.67313 7.38462 2.79993V13.6036ZM14.7692 13.6036C12.8198 12.6896 10.5648 12.6896 8.61538 13.6036V2.79993C10.5119 1.67313 12.8727 1.67313 14.7692 2.79993V13.6036Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </div>
                              <h6 className="mb-0 ms-3 me-auto">Lectures</h6>
                              <span>32</span>
                            </li>
                            <li className="list-group-item d-flex align-items-center py-3">
                              <div className="text-secondary d-flex icon-uxs">
                                <svg
                                  width={20}
                                  height={20}
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M17.1947 7.06802L14.6315 7.9985C14.2476 7.31186 13.712 6.71921 13.0544 6.25992C12.8525 6.11877 12.6421 5.99365 12.4252 5.88303C13.0586 5.25955 13.452 4.39255 13.452 3.43521C13.452 1.54098 11.9124 -1.90735e-06 10.0197 -1.90735e-06C8.12714 -1.90735e-06 6.58738 1.54098 6.58738 3.43521C6.58738 4.39255 6.98075 5.25955 7.61414 5.88303C7.39731 5.99365 7.1869 6.11877 6.98502 6.25992C6.32752 6.71921 5.79178 7.31186 5.40787 7.9985L2.8447 7.06802C2.33612 6.88339 1.79688 7.26044 1.79688 7.80243V16.5178C1.79688 16.8465 2.00256 17.14 2.31155 17.2522L9.75312 19.9536C9.93073 20.018 10.1227 20.0128 10.2863 19.9536L17.7278 17.2522C18.0368 17.14 18.2425 16.8465 18.2425 16.5178V7.80243C18.2425 7.26135 17.704 6.88309 17.1947 7.06802ZM10.0197 1.5625C11.0507 1.5625 11.8895 2.40265 11.8895 3.43521C11.8895 4.46777 11.0507 5.30792 10.0197 5.30792C8.98866 5.30792 8.14988 4.46777 8.14988 3.43521C8.14988 2.40265 8.98866 1.5625 10.0197 1.5625ZM9.23844 18.1044L3.35938 15.9703V8.91724L9.23844 11.0513V18.1044ZM10.0197 9.67255L6.90644 8.54248C7.58164 7.51892 8.75184 6.87042 10.0197 6.87042C11.2875 6.87042 12.4577 7.51892 13.1329 8.54248L10.0197 9.67255ZM16.68 15.9703L10.8009 18.1044V11.0513L16.68 8.91724V15.9703Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </div>
                              <h6 className="mb-0 ms-3 me-auto">Enrolled</h6>
                              <span>1982 students</span>
                            </li>
                            <li className="list-group-item d-flex align-items-center py-3">
                              <div className="text-secondary d-flex icon-uxs">
                                <svg
                                  width={20}
                                  height={20}
                                  viewBox="0 0 20 20"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.5465 5.13024L15.2322 4.02945L14.9329 2.34131C14.8335 1.78023 14.348 1.37335 13.7783 1.37335C13.778 1.37335 13.7775 1.37335 13.7772 1.37335L12.0628 1.37488L10.7485 0.274205C10.3114 -0.0919028 9.67738 -0.0913556 9.24091 0.275574L7.92861 1.37875L6.2142 1.38035C5.64405 1.3809 5.15872 1.78887 5.06026 2.35042L4.76408 4.03907L3.45178 5.14228C3.01535 5.50917 2.90582 6.13362 3.19137 6.62712L4.04992 8.1111L3.75378 9.79967C3.65524 10.3613 3.97276 10.91 4.50875 11.1046L5.9543 11.6292L5.95989 18.8268C5.95989 19.2647 6.20095 19.6629 6.58899 19.8659C6.76059 19.9556 6.94712 20 7.13295 20C7.36737 20 7.60062 19.9294 7.8013 19.7901L9.9861 18.2734L12.1709 19.7901C12.5306 20.0398 12.9951 20.0689 13.3832 19.8659C13.7712 19.6629 14.0123 19.2647 14.0123 18.8268V11.6377L15.5005 11.0945C16.0361 10.899 16.3526 10.3496 16.2531 9.78825L15.9538 8.10015L16.8096 6.61461C17.0943 6.12056 16.9836 5.49631 16.5465 5.13024ZM10.3205 17.078C10.1194 16.9385 9.85281 16.9385 9.65178 17.078L7.13264 18.8265C7.13264 18.8264 7.13264 18.8263 7.13264 18.8263L7.12842 13.3771C7.35154 13.6218 7.66652 13.7592 7.99315 13.7592C8.12738 13.7592 8.26357 13.7361 8.39608 13.6877L10.0065 13.0999L11.6181 13.6848C12.0517 13.842 12.5242 13.7298 12.8396 13.4196L12.8395 18.8266L10.3205 17.078ZM14.9377 7.51475C14.8003 7.75327 14.7511 8.03382 14.7992 8.30482L15.0984 9.99292L13.4878 10.5808C13.286 10.6545 13.1095 10.783 12.9761 10.949C12.9697 10.9566 12.9639 10.9647 12.9579 10.9727C12.9277 11.0123 12.899 11.0533 12.8739 11.0969L12.0185 12.5825C12.0185 12.5825 12.0183 12.5825 12.0181 12.5824L10.4065 11.9976C10.1478 11.9037 9.86297 11.9039 9.6044 11.9983L7.99393 12.5861L7.13538 11.1022C7.08925 11.0224 7.03339 10.9496 6.97073 10.8835C6.96507 10.8774 6.95975 10.871 6.95381 10.8652C6.83236 10.7425 6.68464 10.6468 6.52039 10.5871L4.90882 10.0022L5.205 8.31358C5.2525 8.04245 5.20277 7.76199 5.06495 7.52378L4.20639 6.03984L5.51869 4.93663C5.72942 4.75952 5.87163 4.51263 5.91912 4.24159L6.2153 2.55298L7.92963 2.55138C8.20489 2.55114 8.47254 2.45346 8.68319 2.27635L9.99549 1.17318L11.3098 2.27389C11.5205 2.45041 11.7879 2.54759 12.0629 2.54759H12.0638L13.7783 2.54602L14.0775 4.23416C14.1255 4.50517 14.2682 4.75166 14.4792 4.92842L15.7935 6.02921L14.9377 7.51475Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M9.99928 3.64673C8.13493 3.64673 6.61816 5.1635 6.61816 7.02785C6.61816 8.89221 8.13493 10.409 9.99928 10.409C11.8636 10.409 13.3804 8.89221 13.3804 7.02785C13.3804 5.1635 11.8636 3.64673 9.99928 3.64673ZM9.99928 9.23631C8.78154 9.23631 7.79083 8.2456 7.79083 7.02785C7.79083 5.81011 8.78154 4.8194 9.99928 4.8194C11.217 4.8194 12.2078 5.81011 12.2078 7.02785C12.2078 8.2456 11.217 9.23631 9.99928 9.23631Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </div>
                              <h6 className="mb-0 ms-3 me-auto">Certificate</h6>
                              <span>Yes</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="segment-single notes">
                  <h3>Notatka</h3>
                  <div
                    style={{
                      position: "relative",
                    }}
                    className="mb-5"
                  >
                    <MobiTextarea
                      onChange={(e) => {
                        setNewNoteText(e.target.value);
                      }}
                      value={newNoteText}
                      placeholder={noteTaking ? "Uzupełnij notatkę" : undefined}
                      rows={10}
                    />
                    {!noteTaking ? (
                      <Button
                        onClick={() => {
                          setNoteTaking(true);

                          console.log(notes);
                        }}
                        style={{
                          position: "absolute",
                          top: "calc(50% - 27px)",
                          left: "calc( 50% - 90px )",
                        }}
                        color="secondary"
                        label="DODAJ NOTATKĘ"
                      />
                    ) : (
                      <div className="row justify-content-start mt-3">
                        <div
                          className="col-auto"
                          style={{ display: "inline-flex" }}
                        >
                          <Button
                            onClick={() => {
                              setNoteTaking(false);

                              var d = new Date();

                              let newDate =
                                ("0" + d.getHours()).slice(-2) +
                                ":" +
                                ("0" + d.getMinutes()).slice(-2) +
                                " " +
                                ("0" + d.getDate()).slice(-2) +
                                "-" +
                                ("0" + (d.getMonth() + 1)).slice(-2) +
                                "-" +
                                d.getFullYear();

                              setNotes([
                                ...notes,
                                {
                                  id: getRandomInt(0, 100000000),
                                  note: newNoteText,
                                  buttonText: "Matematyka - Podstawy geometrii",
                                  buttonTime:
                                    getRandomInt(0, 3).toString() +
                                    ":" +
                                    getRandomInt(10, 60) +
                                    ":" +
                                    getRandomInt(10, 60),
                                  date: newDate,
                                },
                              ]);

                              setNewNoteText("");
                            }}
                            style={{
                              width: "130px",
                            }}
                            color="primary"
                            label="ZAPISZ"
                          />
                          <Button
                            onClick={() => {
                              setNoteTaking(false);
                              setNewNoteText("");
                            }}
                            style={{
                              width: "130px",
                            }}
                            color="danger"
                            label="ANULUJ"
                            className="mx-3"
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  {notes.length > 0 ? (
                    <>
                      <h3>Lista notatek</h3>
                      <div className="mb-8">
                        <IonList
                          lines="none"
                          style={{
                            padding: "30px 15px",
                            maxHeight: "MIN( 1200px, 80vh )",
                            overflow: "auto",
                            background: "white",
                          }}
                          className="shadow-basic rounded"
                        >
                          {notes.map((e) => {
                            return (
                              <IonItem
                                style={{
                                  borderRadius: "14px",
                                  margin: "10px 0",
                                  border: "var(--ion-shadow-border-primary)",
                                }}
                              >
                                <div
                                  style={{
                                    width: "100%",
                                  }}
                                >
                                  <div className="row">
                                    <div
                                      className="col-auto"
                                      style={{
                                        margin: "0 14px",
                                        fontSize: "18px",
                                        marginTop: "7px",
                                      }}
                                    >
                                      {e.note.length > 500
                                        ? e.note.substring(0, 500) + "..."
                                        : e.note}
                                    </div>
                                    {e.note.length > 500 ? (
                                      <div className="row justify-content-center">
                                        <div className="col-auto ">
                                          <Button
                                            height={35}
                                            style={{
                                              fontWeight: "600",
                                              display: "block",
                                            }}
                                            fill="clear"
                                            color="secondary"
                                          >
                                            Zobacza więcej
                                          </Button>
                                        </div>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div className="row justify-content-between">
                                    <div className="col-auto">
                                      <Button
                                        height={20}
                                        fontSize={13}
                                        fill="clear"
                                      >
                                        <strong>{e.buttonTime}</strong>
                                        &nbsp;|&nbsp;
                                        {e.buttonText}
                                      </Button>
                                    </div>
                                    <div
                                      className="col-auto text-right"
                                      style={{
                                        display: "inline-flex",
                                      }}
                                    >
                                      <Button
                                        height={20}
                                        fontSize={13}
                                        style={{
                                          fontWeight: "700",
                                        }}
                                        className="show-on-hover"
                                        fill="clear"
                                        color="danger"
                                        onClick={() => {
                                          setNotes(
                                            notes.filter(function (obj) {
                                              return obj.id !== e.id;
                                            })
                                          );
                                        }}
                                        label="USUŃ NOTATKĘ"
                                      ></Button>
                                      <Button
                                        height={20}
                                        fontSize={13}
                                        style={{
                                          fontWeight: "700",
                                          pointerEvents: "none",
                                        }}
                                        fill="clear"
                                        color="medium"
                                      >
                                        {e.date}
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </IonItem>
                            );
                          })}
                        </IonList>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="segment-single description">
                  <div className="mb-0 mb-md-4 d-lg-block">
                    <h1 id="lesson-title" className="pt-3 pb-3 mb-0">
                      Matematyka - Podstawy geometrii
                    </h1>
                  </div>

                  <h3>Course Description</h3>
                  <p className="mb-6 line-height-md">
                    Do you want to become a UI/UX designer but you don't know
                    where to start? This course will allow you to develop your
                    user interface design skills and you can add UI designer to
                    your CV and start getting clients for your skills.
                  </p>
                  <p className="mb-6 line-height-md">
                    Hi everyone. I'm Arash and I'm a UI/UX designer. In this
                    course, I will help you learn and master Figma app
                    comprehensively from scratch. Figma is an innovative and
                    brilliant tool for User Interface design. It's used by
                    everyone from entrepreneurs and start-ups to Apple, Airbnb,
                    Facebook, etc.
                  </p>
                  <p
                    className="collapse mb-6 line-height-md"
                    id="readcollapseExample"
                  >
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. Nihil anim keffiyeh
                    helvetica, craft beer labore wes anderson cred nesciunt
                    sapiente I will help you learn and master Figma app
                    comprehensively from scratch. Figma is an innovative and
                    brilliant tool for User Interface design. It's used by
                    everyone from entrepreneurs ea proident.
                  </p>
                  <h3 className="mb-5">What you'll learn</h3>
                  <div className="row row-cols-lg-2 mb-8">
                    <div className="col-md">
                      <ul className="list-style-v1 list-unstyled">
                        <li>Become a UI/UX designer.</li>
                        <li>You will be able to start earning money skills.</li>
                        <li>Build a UI project from beginning to end.</li>
                        <li>Work with colors &amp; fonts.</li>
                        <li>You will create your own UI Kit.</li>
                      </ul>
                    </div>
                    <div className="col-md">
                      <ul className="list-style-v1 list-unstyled ms-xl-6">
                        <li>Build &amp; test a complete mobile app.</li>
                        <li>Learn to design mobile apps &amp; websites.</li>
                        <li>Design 3 different logos.</li>
                        <li>Create low-fidelity wireframe.</li>
                        <li>Downloadable exercise files.</li>
                      </ul>
                    </div>
                  </div>
                  <div id="Instructor" className="mb-10">
                    <h3 className="mb-6">About the instructor</h3>
                    <div className="d-flex align-items-center mb-6">
                      <div className="d-inline-block rounded-circle border me-6 p-2">
                        <div className="avatar avatar-size-120">
                          <IonImg
                            src="assets/img/avatars/avatar-2.jpg"
                            alt="..."
                            className="avatar-img rounded-circle"
                          />
                        </div>
                      </div>
                      <div className="media-body">
                        <h4 className="mb-0">Lauren Handerson</h4>
                        <span>iOS Developer &amp; UI Designer</span>
                      </div>
                    </div>
                    <div className="row mx-xl-n5 mb-6">
                      <div className="col-12 col-md-auto mb-3 mb-md-0 px-xl-5">
                        <div className="d-flex align-items-center">
                          <div className="me-3 d-flex text-secondary icon-uxs">
                            {/* Icon */}
                            <svg
                              width="16px"
                              height="16px"
                              viewBox="0 -10 511.98685 511"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill="currentColor"
                                d="m114.59375 491.140625c-5.609375 0-11.179688-1.75-15.933594-5.1875-8.855468-6.417969-12.992187-17.449219-10.582031-28.09375l32.9375-145.089844-111.703125-97.960937c-8.210938-7.167969-11.347656-18.519532-7.976562-28.90625 3.371093-10.367188 12.542968-17.707032 23.402343-18.710938l147.796875-13.417968 58.433594-136.746094c4.308594-10.046875 14.121094-16.535156 25.023438-16.535156 10.902343 0 20.714843 6.488281 25.023437 16.511718l58.433594 136.769532 147.773437 13.417968c10.882813.980469 20.054688 8.34375 23.425782 18.710938 3.371093 10.367187.253906 21.738281-7.957032 28.90625l-111.703125 97.941406 32.9375 145.085938c2.414063 10.667968-1.726562 21.699218-10.578125 28.097656-8.832031 6.398437-20.609375 6.890625-29.910156 1.300781l-127.445312-76.160156-127.445313 76.203125c-4.308594 2.558594-9.109375 3.863281-13.953125 3.863281zm141.398438-112.875c4.84375 0 9.640624 1.300781 13.953124 3.859375l120.277344 71.9375-31.085937-136.941406c-2.21875-9.746094 1.089843-19.921875 8.621093-26.515625l105.472657-92.5-139.542969-12.671875c-10.046875-.917969-18.6875-7.234375-22.613281-16.492188l-55.082031-129.046875-55.148438 129.066407c-3.882812 9.195312-12.523438 15.511718-22.546875 16.429687l-139.5625 12.671875 105.46875 92.5c7.554687 6.613281 10.859375 16.769531 8.621094 26.539062l-31.0625 136.9375 120.277343-71.914062c4.308594-2.558594 9.109376-3.859375 13.953126-3.859375zm-84.585938-221.847656s0 .023437-.023438.042969zm169.128906-.0625.023438.042969c0-.023438 0-.023438-.023438-.042969zm0 0"
                              />
                            </svg>
                          </div>
                          4.87 Instructor rating
                        </div>
                      </div>
                      <div className="col-12 col-md-auto mb-3 mb-md-0 px-xl-5">
                        <div className="d-flex align-items-center">
                          <div className="me-3 d-flex text-secondary icon-uxs">
                            {/* Icon */}
                            <svg
                              width={20}
                              height={20}
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.96092 7.89061C10.3924 7.89061 10.7422 8.24034 10.7422 8.67186C10.7422 9.10338 10.3924 9.45311 9.96092 9.45311C9.5294 9.45311 9.17967 9.10338 9.17967 8.67186C9.17967 8.24034 9.5294 7.89061 9.96092 7.89061ZM12.6953 8.67186C12.6953 9.10338 13.045 9.45311 13.4765 9.45311C13.9081 9.45311 14.2578 9.10338 14.2578 8.67186C14.2578 8.24034 13.9081 7.89061 13.4765 7.89061C13.045 7.89061 12.6953 8.24034 12.6953 8.67186ZM5.66405 8.67186C5.66405 9.10338 6.01378 9.45311 6.4453 9.45311C6.87682 9.45311 7.22655 9.10338 7.22655 8.67186C7.22655 8.24034 6.87682 7.89061 6.4453 7.89061C6.01378 7.89061 5.66405 8.24034 5.66405 8.67186ZM19.313 15.9985C20.2273 16.9128 20.2273 18.3996 19.3135 19.3135C18.8566 19.7703 18.2563 19.9989 17.6562 19.9989C17.0561 19.9989 16.4558 19.7703 15.999 19.3135L11.7103 15.0345C11.6192 14.9435 11.5521 14.8317 11.5147 14.7084L10.5806 11.6333C10.4977 11.3606 10.5699 11.0646 10.7689 10.8606C10.9678 10.6567 11.262 10.5774 11.5367 10.6534L14.6899 11.5268C14.8198 11.5628 14.938 11.6316 15.0334 11.7268L19.313 15.9985ZM12.9527 14.0667L15.8468 16.9545L16.9519 15.8494L14.0748 12.9779L12.4885 12.5384L12.9527 14.0667ZM18.2086 17.1038L18.0578 16.9532L16.9529 18.0581L17.1032 18.208C17.4084 18.5133 17.904 18.5133 18.2086 18.2086C18.5133 17.904 18.5133 17.4084 18.2086 17.1038ZM10.4346 16.1895C10.2902 16.1958 10.144 16.199 9.99998 16.199C8.74373 16.199 7.53432 15.9651 6.40547 15.5038C6.21321 15.4254 5.99746 15.4266 5.80611 15.5073L2.24884 17.0089L3.44741 14.1697C3.5646 13.8922 3.51165 13.5718 3.31115 13.3465C2.1672 12.0614 1.5625 10.5238 1.5625 8.90028C1.5625 4.85427 5.34759 1.5625 9.99998 1.5625C14.6524 1.5625 18.4375 4.85427 18.4375 8.90028C18.4375 9.85975 18.2019 10.823 17.7371 11.7631C17.5459 12.1499 17.7044 12.6185 18.0912 12.8097C18.4781 13.0009 18.9466 12.8424 19.1378 12.4556C19.7099 11.2982 20 10.1021 20 8.90028C20 3.99261 15.514 0 9.99998 0C4.48608 0 0 3.99261 0 8.90028C0 10.7527 0.628051 12.507 1.82174 14.0031L0.0614928 18.1727C-0.0621032 18.4655 0.00411988 18.8041 0.228881 19.0289C0.378417 19.1784 0.578154 19.2578 0.781401 19.2578C0.883787 19.2578 0.987089 19.2376 1.08505 19.1963L6.12136 17.0703C7.34969 17.5291 8.65294 17.7615 9.99998 17.7615C10.1666 17.7615 10.3358 17.7577 10.5029 17.7505C10.934 17.7316 11.2681 17.3669 11.2492 16.9359C11.2304 16.5048 10.865 16.1696 10.4346 16.1895Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          1,533 reviews
                        </div>
                      </div>
                      <div className="col-12 col-md-auto mb-3 mb-md-0 px-xl-5">
                        <div className="d-flex align-items-center">
                          <div className="me-3 d-flex text-secondary icon-uxs">
                            <svg
                              width={20}
                              height={20}
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.1947 7.06802L14.6315 7.9985C14.2476 7.31186 13.712 6.71921 13.0544 6.25992C12.8525 6.11877 12.6421 5.99365 12.4252 5.88303C13.0586 5.25955 13.452 4.39255 13.452 3.43521C13.452 1.54098 11.9124 -1.90735e-06 10.0197 -1.90735e-06C8.12714 -1.90735e-06 6.58738 1.54098 6.58738 3.43521C6.58738 4.39255 6.98075 5.25955 7.61414 5.88303C7.39731 5.99365 7.1869 6.11877 6.98502 6.25992C6.32752 6.71921 5.79178 7.31186 5.40787 7.9985L2.8447 7.06802C2.33612 6.88339 1.79688 7.26044 1.79688 7.80243V16.5178C1.79688 16.8465 2.00256 17.14 2.31155 17.2522L9.75312 19.9536C9.93073 20.018 10.1227 20.0128 10.2863 19.9536L17.7278 17.2522C18.0368 17.14 18.2425 16.8465 18.2425 16.5178V7.80243C18.2425 7.26135 17.704 6.88309 17.1947 7.06802ZM10.0197 1.5625C11.0507 1.5625 11.8895 2.40265 11.8895 3.43521C11.8895 4.46777 11.0507 5.30792 10.0197 5.30792C8.98866 5.30792 8.14988 4.46777 8.14988 3.43521C8.14988 2.40265 8.98866 1.5625 10.0197 1.5625ZM9.23844 18.1044L3.35938 15.9703V8.91724L9.23844 11.0513V18.1044ZM10.0197 9.67255L6.90644 8.54248C7.58164 7.51892 8.75184 6.87042 10.0197 6.87042C11.2875 6.87042 12.4577 7.51892 13.1329 8.54248L10.0197 9.67255ZM16.68 15.9703L10.8009 18.1044V11.0513L16.68 8.91724V15.9703Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          23,912 students
                        </div>
                      </div>
                      <div className="col-12 col-md-auto mb-3 mb-md-0 px-xl-5">
                        <div className="d-flex align-items-center">
                          <div className="me-3 d-flex text-secondary icon-uxs">
                            {/* Icon */}
                            <svg
                              width={14}
                              height={16}
                              viewBox="0 0 14 16"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12.8704 6.15374L3.42038 0.328572C2.73669 -0.0923355 1.9101 -0.109836 1.20919 0.281759C0.508282 0.673291 0.0898438 1.38645 0.0898438 2.18929V13.7866C0.0898438 15.0005 1.06797 15.9934 2.27016 16C2.27344 16 2.27672 16 2.27994 16C2.65563 16 3.04713 15.8822 3.41279 15.6591C3.70694 15.4796 3.79991 15.0957 3.62044 14.8016C3.44098 14.5074 3.05697 14.4144 2.76291 14.5939C2.59188 14.6982 2.42485 14.7522 2.27688 14.7522C1.82328 14.7497 1.33763 14.3611 1.33763 13.7866V2.18933C1.33763 1.84492 1.51713 1.53907 1.81775 1.3711C2.11841 1.20314 2.47294 1.21064 2.76585 1.39098L12.2159 7.21615C12.4999 7.39102 12.6625 7.68262 12.6618 8.01618C12.6611 8.34971 12.4974 8.64065 12.2118 8.81493L5.37935 12.9983C5.08548 13.1783 4.9931 13.5623 5.17304 13.8562C5.35295 14.1501 5.73704 14.2424 6.03092 14.0625L12.8625 9.87962C13.5166 9.48059 13.9081 8.78496 13.9096 8.01868C13.9112 7.25249 13.5226 6.55524 12.8704 6.15374Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          29 courses
                        </div>
                      </div>
                    </div>
                    <p className="mb-6 line-height-md">
                      I am a UI/UX designer and an iOS developer with having
                      almost six years of experience in application development
                      and also ten years of graphic design and User Interface
                      design.
                    </p>
                    <p className="mb-6 line-height-md">
                      My passion is helping people to learn new skills in a
                      short-term course and achieve their goals. I've been
                      designing for more than ten years and developing iOS apps
                      for four years. It's my honor if I could help you learn to
                      program in a simple word. I currently am teaching iOS 13,
                      Swift 5, ARKit 3, Sketch 5, Illustrator, Photoshop, Cinema
                      4D, HTML, CSS, JavaScript, etc.
                    </p>
                  </div>
                </div>

                <div className="segment-single comments">
                  <h3 className="mb-6">Komentarze</h3>
                  <ul className="list-unstyled pt-2">
                    <li className="media d-flex">
                      <div className="avatar avatar-xxl me-3 me-md-6 flex-shrink-0">
                        <img
                          src="assets/img/avatars/avatar-1.jpg"
                          alt="..."
                          className="avatar-img rounded-circle"
                        />
                      </div>
                      <div className="media-body flex-grow-1 mb-6">
                        <div className="d-md-flex align-items-center">
                          <div className="me-auto mb-4 mb-md-0">
                            <h5 className="mb-0">Oscar Cafeo</h5>
                            <p className="font-size-sm font-italic">
                              Beautiful courses
                            </p>
                          </div>
                        </div>
                        <p className="line-height-md mb-0">
                          This course was well organized and covered a lot more
                          details than any other Figma courses. I really enjoy
                          it. One suggestion is that it can be much better if we
                          could complete the prototype together. Since we
                          created 24 frames, I really want to test it on Figma
                          mirror to see all the connections. Could you please
                          let me take a look at the complete prototype?
                        </p>
                        <Button
                          label="Odpowiedz na komentarz"
                          color="primary"
                          fill="clear"
                          height={30}
                          className="mt-1 mt-md-0 response-button"
                          style={{
                            float: "right",
                          }}
                        />
                      </div>
                    </li>
                    <li className="media d-flex">
                      <div className="avatar avatar-xxl me-3 me-md-6 flex-shrink-0">
                        <IonImg
                          src="assets/img/avatars/avatar-2.jpg"
                          alt="..."
                          className="avatar-img rounded-circle"
                        />
                      </div>
                      <div className="media-body flex-grow-1">
                        <div className="d-md-flex align-items-center">
                          <div className="me-auto mb-4 mb-md-0">
                            <h5 className="mb-0">Alex Morgan</h5>
                            <p className="font-size-sm font-italic">
                              Beautiful courses
                            </p>
                          </div>
                        </div>
                        <p className="mb-0 line-height-md">
                          This course was well organized and covered a lot more
                          details than any other Figma courses. I really enjoy
                          it. One suggestion is that it can be much better if we
                          could complete the prototype together. Since we
                          created 24 frames, I really want to test it on Figma
                          mirror to see all the connections. Could you please
                          let me take a look at the complete prototype?
                        </p>
                        <Button
                          label="Odpowiedz na komentarz"
                          color="primary"
                          fill="clear"
                          height={30}
                          className="mt-1 mt-md-0 response-button"
                          style={{
                            float: "right",
                          }}
                        />
                      </div>
                    </li>
                  </ul>
                  <div className="p-3 mb-8">
                    <h3 className="mb-3">Dodaj komentarz</h3>
                    <div className="row">
                      <div className="col-12">
                        <MobiTextarea rows={10} />
                      </div>
                    </div>
                    <div className="row justify-content-end mt-3">
                      <div className="col-auto">
                        <Button color="primary" label="DODAJ" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 segment-single lessons d-lg-block">
              <div
                className="rounded p-0 p-md-6"
                style={{
                  background: "var(--ion-color-secondary)",
                }}
              >
                <IonAccordionGroup
                  multiple={!(isPlatform("mobile") || isPlatform("tablet"))}
                  // value={accordionValue}
                  // onIonChange={(e) => {
                  //   setAccordionValue(e.detail.value);
                  // }}
                  ref={ionAccordionRef}
                >
                  <IonAccordion
                    toggleIcon=""
                    className="mb-md-6"
                    style={{
                      "--ion-background-color": "#08214a",
                    }}
                    value="tobuy"
                  >
                    <IonItem slot="header">
                      <div className="d-flex align-items-center">
                        <h5 className="mb-0 w-100">
                          <button
                            className="d-flex align-items-center p-5 min-height-80 text-white fw-medium collapse-accordion-toggle line-height-one"
                            type="button"
                          >
                            <span className="me-4 text-white d-flex">
                              {/* Icon */}
                              <svg
                                width={15}
                                height={2}
                                viewBox="0 0 15 2"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  width={15}
                                  height={2}
                                  fill="currentColor"
                                />
                              </svg>
                              <svg
                                width={15}
                                height={16}
                                viewBox="0 0 15 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M0 7H15V9H0V7Z" fill="currentColor" />
                                <path
                                  d="M6 16L6 8.74228e-08L8 0L8 16H6Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            Wprowadzenie
                          </button>
                        </h5>
                      </div>
                    </IonItem>

                    <IonList lines="none" slot="content">
                      <IonItem>
                        <div
                          className="border-top px-5 border-color-20 py-4 min-height-70 d-md-flex align-items-center active-lesson"
                          style={{ width: "100%" }}
                        >
                          <div className="d-flex align-items-center me-auto mb-4 mb-md-0">
                            <div
                              className="text-white me-4"
                              style={{
                                fontWeight: "600",
                                fontSize: "18px",
                                lineHeight: "24px",
                              }}
                            >
                              Introduction to the course
                            </div>
                          </div>
                          <div className="d-flex align-items-center overflow-auto overflow-md-visible flex-shrink-all">
                            <div className="badge btn-orange-soft text-white-70 me-5 font-size-sm fw-normal py-2">
                              30 min
                            </div>
                            <a href="#" className="text-secondary d-flex">
                              {/* Icon */}
                              <svg
                                width={14}
                                height={16}
                                viewBox="0 0 14 16"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.8704 6.15374L3.42038 0.328572C2.73669 -0.0923355 1.9101 -0.109836 1.20919 0.281759C0.508282 0.673291 0.0898438 1.38645 0.0898438 2.18929V13.7866C0.0898438 15.0005 1.06797 15.9934 2.27016 16C2.27344 16 2.27672 16 2.27994 16C2.65563 16 3.04713 15.8822 3.41279 15.6591C3.70694 15.4796 3.79991 15.0957 3.62044 14.8016C3.44098 14.5074 3.05697 14.4144 2.76291 14.5939C2.59188 14.6982 2.42485 14.7522 2.27688 14.7522C1.82328 14.7497 1.33763 14.3611 1.33763 13.7866V2.18933C1.33763 1.84492 1.51713 1.53907 1.81775 1.3711C2.11841 1.20314 2.47294 1.21064 2.76585 1.39098L12.2159 7.21615C12.4999 7.39102 12.6625 7.68262 12.6618 8.01618C12.6611 8.34971 12.4974 8.64065 12.2118 8.81493L5.37935 12.9983C5.08548 13.1783 4.9931 13.5623 5.17304 13.8562C5.35295 14.1501 5.73704 14.2424 6.03092 14.0625L12.8625 9.87962C13.5166 9.48059 13.9081 8.78496 13.9096 8.01868C13.9112 7.25249 13.5226 6.55524 12.8704 6.15374Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </IonItem>
                      <IonItem>
                        <div
                          className="border-top px-5 border-color-20 py-4 min-height-70 d-md-flex align-items-center"
                          style={{ width: "100%" }}
                        >
                          <div className="d-flex align-items-center me-auto mb-4 mb-md-0">
                            <div
                              className="text-white me-4"
                              style={{
                                fontWeight: "600",
                                fontSize: "18px",
                                lineHeight: "24px",
                              }}
                            >
                              Introduction to the course
                            </div>
                          </div>
                          <div className="d-flex align-items-center overflow-auto overflow-md-visible flex-shrink-all">
                            <div className="badge btn-orange-soft text-white-70 me-5 font-size-sm fw-normal py-2">
                              30 min
                            </div>
                            <a href="#" className="text-secondary d-flex">
                              {/* Icon */}
                              <svg
                                width={14}
                                height={16}
                                viewBox="0 0 14 16"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.8704 6.15374L3.42038 0.328572C2.73669 -0.0923355 1.9101 -0.109836 1.20919 0.281759C0.508282 0.673291 0.0898438 1.38645 0.0898438 2.18929V13.7866C0.0898438 15.0005 1.06797 15.9934 2.27016 16C2.27344 16 2.27672 16 2.27994 16C2.65563 16 3.04713 15.8822 3.41279 15.6591C3.70694 15.4796 3.79991 15.0957 3.62044 14.8016C3.44098 14.5074 3.05697 14.4144 2.76291 14.5939C2.59188 14.6982 2.42485 14.7522 2.27688 14.7522C1.82328 14.7497 1.33763 14.3611 1.33763 13.7866V2.18933C1.33763 1.84492 1.51713 1.53907 1.81775 1.3711C2.11841 1.20314 2.47294 1.21064 2.76585 1.39098L12.2159 7.21615C12.4999 7.39102 12.6625 7.68262 12.6618 8.01618C12.6611 8.34971 12.4974 8.64065 12.2118 8.81493L5.37935 12.9983C5.08548 13.1783 4.9931 13.5623 5.17304 13.8562C5.35295 14.1501 5.73704 14.2424 6.03092 14.0625L12.8625 9.87962C13.5166 9.48059 13.9081 8.78496 13.9096 8.01868C13.9112 7.25249 13.5226 6.55524 12.8704 6.15374Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </IonItem>
                      <IonItem>
                        <div
                          className="border-top px-5 border-color-20 py-4 min-height-70 d-md-flex align-items-center"
                          style={{ width: "100%" }}
                        >
                          <div className="d-flex align-items-center me-auto mb-4 mb-md-0">
                            <div
                              className="text-white me-4"
                              style={{
                                fontWeight: "600",
                                fontSize: "18px",
                                lineHeight: "24px",
                              }}
                            >
                              Introduction to the course
                            </div>
                          </div>
                          <div className="d-flex align-items-center overflow-auto overflow-md-visible flex-shrink-all">
                            <div className="badge btn-orange-soft text-white-70 me-5 font-size-sm fw-normal py-2">
                              30 min
                            </div>
                            <a href="#" className="text-secondary d-flex">
                              {/* Icon */}
                              <svg
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15.625 7.34375H7.3423V4.13164C7.3423 2.715 8.53391 1.5625 9.99855 1.5625C11.4632 1.5625 12.6548 2.715 12.6548 4.13164V5.625H14.2173V4.13164C14.2173 1.85344 12.3248 0 9.99855 0C7.67234 0 5.7798 1.85344 5.7798 4.13164V7.34375H4.375C3.08266 7.34375 2.03125 8.39516 2.03125 9.6875V17.6562C2.03125 18.9486 3.08266 20 4.375 20H15.625C16.9173 20 17.9688 18.9486 17.9688 17.6562V9.6875C17.9688 8.39516 16.9173 7.34375 15.625 7.34375ZM16.4062 17.6562C16.4062 18.087 16.0558 18.4375 15.625 18.4375H4.375C3.94422 18.4375 3.59375 18.087 3.59375 17.6562V9.6875C3.59375 9.25672 3.94422 8.90625 4.375 8.90625H15.625C16.0558 8.90625 16.4062 9.25672 16.4062 9.6875V17.6562Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M10 11.1719C9.20176 11.1719 8.55469 11.8189 8.55469 12.6172C8.55469 13.1269 8.81875 13.5746 9.2173 13.832V15.5469C9.2173 15.9783 9.56707 16.3281 9.99855 16.3281C10.43 16.3281 10.7798 15.9783 10.7798 15.5469V13.8338C11.18 13.5768 11.4453 13.1281 11.4453 12.6172C11.4453 11.8189 10.7982 11.1719 10 11.1719Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </IonItem>
                    </IonList>
                  </IonAccordion>
                  <IonAccordion
                    toggleIcon=""
                    className="mb-6"
                    style={{
                      "--ion-background-color": "#08214a",
                    }}
                    value="tobuy2"
                  >
                    <IonItem slot="header">
                      <div className="d-flex align-items-center">
                        <h5 className="mb-0 w-100">
                          <button
                            className="d-flex align-items-center p-5 min-height-80 text-white fw-medium collapse-accordion-toggle line-height-one"
                            type="button"
                          >
                            <span className="me-4 text-white d-flex">
                              {/* Icon */}
                              <svg
                                width={15}
                                height={2}
                                viewBox="0 0 15 2"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  width={15}
                                  height={2}
                                  fill="currentColor"
                                />
                              </svg>
                              <svg
                                width={15}
                                height={16}
                                viewBox="0 0 15 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M0 7H15V9H0V7Z" fill="currentColor" />
                                <path
                                  d="M6 16L6 8.74228e-08L8 0L8 16H6Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            Podstawy
                          </button>
                        </h5>
                      </div>
                    </IonItem>

                    <IonList lines="none" slot="content">
                      <IonItem>
                        <div
                          className="border-top px-5 border-color-20 py-4 min-height-70 d-md-flex align-items-center"
                          style={{ width: "100%" }}
                        >
                          <div className="d-flex align-items-center me-auto mb-4 mb-md-0">
                            <div
                              className="text-white me-4"
                              style={{
                                fontWeight: "600",
                                fontSize: "18px",
                                lineHeight: "24px",
                              }}
                            >
                              Introduction to the course
                            </div>
                          </div>
                          <div className="d-flex align-items-center overflow-auto overflow-md-visible flex-shrink-all">
                            <div className="badge btn-orange-soft text-white-70 me-5 font-size-sm fw-normal py-2">
                              30 min
                            </div>
                            <a href="#" className="text-secondary d-flex">
                              {/* Icon */}
                              <svg
                                width={14}
                                height={16}
                                viewBox="0 0 14 16"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.8704 6.15374L3.42038 0.328572C2.73669 -0.0923355 1.9101 -0.109836 1.20919 0.281759C0.508282 0.673291 0.0898438 1.38645 0.0898438 2.18929V13.7866C0.0898438 15.0005 1.06797 15.9934 2.27016 16C2.27344 16 2.27672 16 2.27994 16C2.65563 16 3.04713 15.8822 3.41279 15.6591C3.70694 15.4796 3.79991 15.0957 3.62044 14.8016C3.44098 14.5074 3.05697 14.4144 2.76291 14.5939C2.59188 14.6982 2.42485 14.7522 2.27688 14.7522C1.82328 14.7497 1.33763 14.3611 1.33763 13.7866V2.18933C1.33763 1.84492 1.51713 1.53907 1.81775 1.3711C2.11841 1.20314 2.47294 1.21064 2.76585 1.39098L12.2159 7.21615C12.4999 7.39102 12.6625 7.68262 12.6618 8.01618C12.6611 8.34971 12.4974 8.64065 12.2118 8.81493L5.37935 12.9983C5.08548 13.1783 4.9931 13.5623 5.17304 13.8562C5.35295 14.1501 5.73704 14.2424 6.03092 14.0625L12.8625 9.87962C13.5166 9.48059 13.9081 8.78496 13.9096 8.01868C13.9112 7.25249 13.5226 6.55524 12.8704 6.15374Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </IonItem>
                      <IonItem>
                        <div
                          className="border-top px-5 border-color-20 py-4 min-height-70 d-md-flex align-items-center"
                          style={{ width: "100%" }}
                        >
                          <div className="d-flex align-items-center me-auto mb-4 mb-md-0">
                            <div
                              className="text-white me-4"
                              style={{
                                fontWeight: "600",
                                fontSize: "18px",
                                lineHeight: "24px",
                              }}
                            >
                              Introduction to the course
                            </div>
                          </div>
                          <div className="d-flex align-items-center overflow-auto overflow-md-visible flex-shrink-all">
                            <div className="badge btn-orange-soft text-white-70 me-5 font-size-sm fw-normal py-2">
                              30 min
                            </div>
                            <a href="#" className="text-secondary d-flex">
                              {/* Icon */}
                              <svg
                                width={14}
                                height={16}
                                viewBox="0 0 14 16"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.8704 6.15374L3.42038 0.328572C2.73669 -0.0923355 1.9101 -0.109836 1.20919 0.281759C0.508282 0.673291 0.0898438 1.38645 0.0898438 2.18929V13.7866C0.0898438 15.0005 1.06797 15.9934 2.27016 16C2.27344 16 2.27672 16 2.27994 16C2.65563 16 3.04713 15.8822 3.41279 15.6591C3.70694 15.4796 3.79991 15.0957 3.62044 14.8016C3.44098 14.5074 3.05697 14.4144 2.76291 14.5939C2.59188 14.6982 2.42485 14.7522 2.27688 14.7522C1.82328 14.7497 1.33763 14.3611 1.33763 13.7866V2.18933C1.33763 1.84492 1.51713 1.53907 1.81775 1.3711C2.11841 1.20314 2.47294 1.21064 2.76585 1.39098L12.2159 7.21615C12.4999 7.39102 12.6625 7.68262 12.6618 8.01618C12.6611 8.34971 12.4974 8.64065 12.2118 8.81493L5.37935 12.9983C5.08548 13.1783 4.9931 13.5623 5.17304 13.8562C5.35295 14.1501 5.73704 14.2424 6.03092 14.0625L12.8625 9.87962C13.5166 9.48059 13.9081 8.78496 13.9096 8.01868C13.9112 7.25249 13.5226 6.55524 12.8704 6.15374Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </IonItem>
                      <IonItem>
                        <div
                          className="border-top px-5 border-color-20 py-4 min-height-70 d-md-flex align-items-center"
                          style={{ width: "100%" }}
                        >
                          <div className="d-flex align-items-center me-auto mb-4 mb-md-0">
                            <div
                              className="text-white me-4"
                              style={{
                                fontWeight: "600",
                                fontSize: "18px",
                                lineHeight: "24px",
                              }}
                            >
                              Introduction to the course
                            </div>
                          </div>
                          <div className="d-flex align-items-center overflow-auto overflow-md-visible flex-shrink-all">
                            <div className="badge btn-orange-soft text-white-70 me-5 font-size-sm fw-normal py-2">
                              30 min
                            </div>
                            <a href="#" className="text-secondary d-flex">
                              {/* Icon */}
                              <svg
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15.625 7.34375H7.3423V4.13164C7.3423 2.715 8.53391 1.5625 9.99855 1.5625C11.4632 1.5625 12.6548 2.715 12.6548 4.13164V5.625H14.2173V4.13164C14.2173 1.85344 12.3248 0 9.99855 0C7.67234 0 5.7798 1.85344 5.7798 4.13164V7.34375H4.375C3.08266 7.34375 2.03125 8.39516 2.03125 9.6875V17.6562C2.03125 18.9486 3.08266 20 4.375 20H15.625C16.9173 20 17.9688 18.9486 17.9688 17.6562V9.6875C17.9688 8.39516 16.9173 7.34375 15.625 7.34375ZM16.4062 17.6562C16.4062 18.087 16.0558 18.4375 15.625 18.4375H4.375C3.94422 18.4375 3.59375 18.087 3.59375 17.6562V9.6875C3.59375 9.25672 3.94422 8.90625 4.375 8.90625H15.625C16.0558 8.90625 16.4062 9.25672 16.4062 9.6875V17.6562Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M10 11.1719C9.20176 11.1719 8.55469 11.8189 8.55469 12.6172C8.55469 13.1269 8.81875 13.5746 9.2173 13.832V15.5469C9.2173 15.9783 9.56707 16.3281 9.99855 16.3281C10.43 16.3281 10.7798 15.9783 10.7798 15.5469V13.8338C11.18 13.5768 11.4453 13.1281 11.4453 12.6172C11.4453 11.8189 10.7982 11.1719 10 11.1719Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </IonItem>
                    </IonList>
                  </IonAccordion>
                </IonAccordionGroup>
              </div>
              <div
                className="shadow-basic mt-8 d-none d-lg-block"
                style={{
                  background: "white",
                  padding: 7,
                }}
              >
                <div
                  className="pt-5 pb-4 px-5 px-lg-3 px-xl-5"
                  style={{
                    margin: "auto 0",
                  }}
                >
                  <div className="mb-4">
                    <IonRadioGroup
                      value={selected}
                      onIonChange={(e) => setSelected(e.detail.value)}
                    >
                      <IonItem
                        lines="none"
                        className={
                          selected == "lekcja"
                            ? "border-active-2"
                            : "border-transparent-2"
                        }
                        style={{
                          borderRadius: "14px",
                          marginBottom: "5px",
                        }}
                      >
                        <div className="mb-2 mt-2">
                          <div className="d-flex align-items-center ">
                            <span className="ms-0">Lekcja</span>
                          </div>
                          <div className="d-flex align-items-center mb-0">
                            <ins className="h2 mb-0 ms-2">49,99 zł</ins>
                          </div>
                        </div>
                        <IonRadio slot="end" value="lekcja" />
                      </IonItem>
                      <IonItem
                        lines="none"
                        className={
                          selected == "kurs"
                            ? "border-active-2"
                            : "border-transparent-2"
                        }
                        style={{
                          borderRadius: "14px",
                          marginBottom: "5px",
                        }}
                      >
                        <div className="mb-2 mt-2">
                          <div className="d-flex align-items-center mb-0">
                            <span className="ms-0" style={{}}>
                              Cały kurs
                            </span>
                          </div>
                          <div className="d-flex align-items-center mb-0">
                            <ins className="h2 mb-0 ms-2">359,00 zł</ins>
                            <del
                              className="ms-3"
                              style={{
                                marginTop: "-18px",
                              }}
                            >
                              599,00 zł
                            </del>
                          </div>
                        </div>
                        <IonRadio slot="end" value="kurs" />
                      </IonItem>
                    </IonRadioGroup>
                  </div>

                  <Button
                    onClick={() => {
                      setTimeout(() => {
                        if (state.cart) {
                          let tempCart = state.cart;
                          tempCart.push({
                            category: "Matematyka",
                            name: "Trygonometria",
                            price: "100,00 zł",
                          });
                          setState((prev) => ({
                            ...prev,
                            ...{ cart: tempCart },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            ...{
                              cart: [
                                {
                                  category: "Matematyka",
                                  name: "Trygonometria",
                                  price: "100,00 zł",
                                },
                              ],
                            },
                          }));
                        }

                        if (ionHeaderRef.current) {
                          const element = ionHeaderRef.current.querySelector(
                            "#popover-cart-click"
                          ) as HTMLDivElement;
                          if (element) {
                            element.click();
                          }
                        }
                      }, 200);
                    }}
                    label="DODAJ DO KOSZYKA"
                    style={{
                      width: "100%",
                    }}
                    height={60}
                    fontSize={18}
                    className="mb-6 prevent-dismiss"
                  />
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex align-items-center py-3">
                      <div className="text-secondary d-flex icon-uxs">
                        <svg
                          width={16}
                          height={16}
                          viewBox="0 0 16 16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.3164 4.20996C13.985 4.37028 13.8464 4.76904 14.0067 5.10026C14.4447 6.00505 14.6667 6.98031 14.6667 8C14.6667 11.6759 11.6759 14.6667 8 14.6667C4.32406 14.6667 1.33333 11.6759 1.33333 8C1.33333 4.32406 4.32406 1.33333 8 1.33333C9.52328 1.33333 10.9543 1.83073 12.1387 2.77165C12.4259 3.00098 12.846 2.95296 13.0754 2.66471C13.3047 2.37663 13.2567 1.95703 12.9683 1.72803C11.5661 0.613607 9.8016 0 8 0C3.58903 0 0 3.58903 0 8C0 12.411 3.58903 16 8 16C12.411 16 16 12.411 16 8C16 6.77767 15.7331 5.60628 15.2067 4.51969C15.0467 4.18766 14.6466 4.04932 14.3164 4.20996Z"
                            fill="currentColor"
                          />
                          <path
                            d="M7.99967 2.66663C7.63167 2.66663 7.33301 2.96529 7.33301 3.33329V7.99996C7.33301 8.36796 7.63167 8.66663 7.99967 8.66663H11.333C11.701 8.66663 11.9997 8.36796 11.9997 7.99996C11.9997 7.63196 11.701 7.33329 11.333 7.33329H8.66634V3.33329C8.66634 2.96529 8.36768 2.66663 7.99967 2.66663Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <h6 className="mb-0 ms-3 me-auto">Duration</h6>
                      <span>43 weeks</span>
                    </li>
                    <li className="list-group-item d-flex align-items-center py-3">
                      <div className="text-secondary d-flex icon-uxs">
                        <svg
                          width={16}
                          height={16}
                          viewBox="0 0 16 16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.7262 1.94825C13.4059 0.396725 10.401 0.315126 8.00002 1.73839C5.59897 0.315126 2.59406 0.396725 0.273859 1.94825C0.102729 2.06241 -3.54271e-05 2.25456 6.30651e-07 2.46027V14.6553C-0.000323889 14.8826 0.124616 15.0914 0.324917 15.1987C0.525109 15.3058 0.768066 15.294 0.9569 15.168C2.98471 13.8111 5.63063 13.8111 7.65844 15.168C7.66645 15.1735 7.67568 15.1747 7.68368 15.1796C7.69169 15.1846 7.7003 15.1932 7.70953 15.1987C7.73102 15.2079 7.75302 15.2159 7.77538 15.2227C7.79773 15.2329 7.82077 15.2415 7.84428 15.2486C7.87828 15.2564 7.91286 15.2616 7.94766 15.264C7.96551 15.264 7.98213 15.2714 7.99998 15.2714C8.00492 15.2714 8.00982 15.2714 8.01538 15.2714C8.03604 15.2699 8.05655 15.2672 8.07693 15.2634C8.10808 15.2602 8.13895 15.2547 8.16923 15.2467C8.19018 15.2399 8.21074 15.2319 8.23078 15.2227C8.24986 15.2147 8.27016 15.2104 8.28862 15.2006C8.29724 15.1956 8.30402 15.1883 8.31264 15.1827C8.32125 15.1772 8.3311 15.1753 8.33971 15.1698C10.3675 13.8129 13.0134 13.8129 15.0413 15.1698C15.3233 15.3595 15.7057 15.2846 15.8953 15.0026C15.9643 14.9 16.0008 14.779 16 14.6554V2.46027C16 2.25456 15.8973 2.06241 15.7262 1.94825ZM7.38462 13.6036C5.43516 12.6896 3.18022 12.6896 1.23076 13.6036V2.79993C3.12732 1.67313 5.48806 1.67313 7.38462 2.79993V13.6036ZM14.7692 13.6036C12.8198 12.6896 10.5648 12.6896 8.61538 13.6036V2.79993C10.5119 1.67313 12.8727 1.67313 14.7692 2.79993V13.6036Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <h6 className="mb-0 ms-3 me-auto">Lectures</h6>
                      <span>32</span>
                    </li>
                    <li className="list-group-item d-flex align-items-center py-3">
                      <div className="text-secondary d-flex icon-uxs">
                        <svg
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.1947 7.06802L14.6315 7.9985C14.2476 7.31186 13.712 6.71921 13.0544 6.25992C12.8525 6.11877 12.6421 5.99365 12.4252 5.88303C13.0586 5.25955 13.452 4.39255 13.452 3.43521C13.452 1.54098 11.9124 -1.90735e-06 10.0197 -1.90735e-06C8.12714 -1.90735e-06 6.58738 1.54098 6.58738 3.43521C6.58738 4.39255 6.98075 5.25955 7.61414 5.88303C7.39731 5.99365 7.1869 6.11877 6.98502 6.25992C6.32752 6.71921 5.79178 7.31186 5.40787 7.9985L2.8447 7.06802C2.33612 6.88339 1.79688 7.26044 1.79688 7.80243V16.5178C1.79688 16.8465 2.00256 17.14 2.31155 17.2522L9.75312 19.9536C9.93073 20.018 10.1227 20.0128 10.2863 19.9536L17.7278 17.2522C18.0368 17.14 18.2425 16.8465 18.2425 16.5178V7.80243C18.2425 7.26135 17.704 6.88309 17.1947 7.06802ZM10.0197 1.5625C11.0507 1.5625 11.8895 2.40265 11.8895 3.43521C11.8895 4.46777 11.0507 5.30792 10.0197 5.30792C8.98866 5.30792 8.14988 4.46777 8.14988 3.43521C8.14988 2.40265 8.98866 1.5625 10.0197 1.5625ZM9.23844 18.1044L3.35938 15.9703V8.91724L9.23844 11.0513V18.1044ZM10.0197 9.67255L6.90644 8.54248C7.58164 7.51892 8.75184 6.87042 10.0197 6.87042C11.2875 6.87042 12.4577 7.51892 13.1329 8.54248L10.0197 9.67255ZM16.68 15.9703L10.8009 18.1044V11.0513L16.68 8.91724V15.9703Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <h6 className="mb-0 ms-3 me-auto">Enrolled</h6>
                      <span>1982 students</span>
                    </li>
                    <li className="list-group-item d-flex align-items-center py-3">
                      <div className="text-secondary d-flex icon-uxs">
                        <svg
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.5465 5.13024L15.2322 4.02945L14.9329 2.34131C14.8335 1.78023 14.348 1.37335 13.7783 1.37335C13.778 1.37335 13.7775 1.37335 13.7772 1.37335L12.0628 1.37488L10.7485 0.274205C10.3114 -0.0919028 9.67738 -0.0913556 9.24091 0.275574L7.92861 1.37875L6.2142 1.38035C5.64405 1.3809 5.15872 1.78887 5.06026 2.35042L4.76408 4.03907L3.45178 5.14228C3.01535 5.50917 2.90582 6.13362 3.19137 6.62712L4.04992 8.1111L3.75378 9.79967C3.65524 10.3613 3.97276 10.91 4.50875 11.1046L5.9543 11.6292L5.95989 18.8268C5.95989 19.2647 6.20095 19.6629 6.58899 19.8659C6.76059 19.9556 6.94712 20 7.13295 20C7.36737 20 7.60062 19.9294 7.8013 19.7901L9.9861 18.2734L12.1709 19.7901C12.5306 20.0398 12.9951 20.0689 13.3832 19.8659C13.7712 19.6629 14.0123 19.2647 14.0123 18.8268V11.6377L15.5005 11.0945C16.0361 10.899 16.3526 10.3496 16.2531 9.78825L15.9538 8.10015L16.8096 6.61461C17.0943 6.12056 16.9836 5.49631 16.5465 5.13024ZM10.3205 17.078C10.1194 16.9385 9.85281 16.9385 9.65178 17.078L7.13264 18.8265C7.13264 18.8264 7.13264 18.8263 7.13264 18.8263L7.12842 13.3771C7.35154 13.6218 7.66652 13.7592 7.99315 13.7592C8.12738 13.7592 8.26357 13.7361 8.39608 13.6877L10.0065 13.0999L11.6181 13.6848C12.0517 13.842 12.5242 13.7298 12.8396 13.4196L12.8395 18.8266L10.3205 17.078ZM14.9377 7.51475C14.8003 7.75327 14.7511 8.03382 14.7992 8.30482L15.0984 9.99292L13.4878 10.5808C13.286 10.6545 13.1095 10.783 12.9761 10.949C12.9697 10.9566 12.9639 10.9647 12.9579 10.9727C12.9277 11.0123 12.899 11.0533 12.8739 11.0969L12.0185 12.5825C12.0185 12.5825 12.0183 12.5825 12.0181 12.5824L10.4065 11.9976C10.1478 11.9037 9.86297 11.9039 9.6044 11.9983L7.99393 12.5861L7.13538 11.1022C7.08925 11.0224 7.03339 10.9496 6.97073 10.8835C6.96507 10.8774 6.95975 10.871 6.95381 10.8652C6.83236 10.7425 6.68464 10.6468 6.52039 10.5871L4.90882 10.0022L5.205 8.31358C5.2525 8.04245 5.20277 7.76199 5.06495 7.52378L4.20639 6.03984L5.51869 4.93663C5.72942 4.75952 5.87163 4.51263 5.91912 4.24159L6.2153 2.55298L7.92963 2.55138C8.20489 2.55114 8.47254 2.45346 8.68319 2.27635L9.99549 1.17318L11.3098 2.27389C11.5205 2.45041 11.7879 2.54759 12.0629 2.54759H12.0638L13.7783 2.54602L14.0775 4.23416C14.1255 4.50517 14.2682 4.75166 14.4792 4.92842L15.7935 6.02921L14.9377 7.51475Z"
                            fill="currentColor"
                          />
                          <path
                            d="M9.99928 3.64673C8.13493 3.64673 6.61816 5.1635 6.61816 7.02785C6.61816 8.89221 8.13493 10.409 9.99928 10.409C11.8636 10.409 13.3804 8.89221 13.3804 7.02785C13.3804 5.1635 11.8636 3.64673 9.99928 3.64673ZM9.99928 9.23631C8.78154 9.23631 7.79083 8.2456 7.79083 7.02785C7.79083 5.81011 8.78154 4.8194 9.99928 4.8194C11.217 4.8194 12.2078 5.81011 12.2078 7.02785C12.2078 8.2456 11.217 9.23631 9.99928 9.23631Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <h6 className="mb-0 ms-3 me-auto">Certificate</h6>
                      <span>Yes</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </IonContent>
    </IonPage>
  );
};

export default Home;
